import LockDetails from './LockDetails';

export default LockDetails;
